import builder from '../builder';
import ProfessionalNetworkLinkedIn from '../../streamline-icons/light/professional-network-linkedin.svg';
export default builder('IconProfessionalNetworkLinkedInLight', ProfessionalNetworkLinkedIn);
//# sourceMappingURL=ProfessionalNetworkLinkedIn.js.map